import React, { Suspense } from "react";
import { SnackbarContent } from "notistack";

const Toast = React.lazy(() => import("../../common/components/Toast/Toast"));

/**
 * Integration Component to Show a Toast
 */
const ToastNotification = React.forwardRef<HTMLDivElement, any>(
    (props, ref) => {
        const {
            // passed via events
            toastProps,
            // native notistack stuff
            ...otherProps
        } = props;

        return (
            <SnackbarContent ref={ref} role="alert" {...otherProps}>
                <Suspense fallback={null}>
                    <Toast {...toastProps} />
                </Suspense>
            </SnackbarContent>
        );
    },
);

export default ToastNotification;
